import React from 'react';
import Container from "./container"
import FormatButtons from './formatPanel'

import './editor.css'

export default class Editor extends React.Component {

  state = {
    contentObj: null,
    selected: null,
    selectedEl: null,
    mode: "edit",
    format: ""
  }

  componentWillMount() {
    this.setState({
      contentObj: this.props.data,
      selected: null,
      mode: "edit"
    })    
  }

  update = () => {
    this.setState({contentObj: this.props.data})  
    this.props.onChange({target: {
      type: "news_editor",
      name: "contentObj",
      value: this.props.data
    }})
  }

  addRow = (e,el,comp) => {
    e.stopPropagation()
    e.preventDefault()    
    el.content.push({
      type: "row",
      content: [{
        type: "col",
        content: {
          type: "new"
        }
      }]
    }) 
    this.update() 
  }
  removeRow = (e,el,comp) => {
    el.content = el.content.filter(row => row != this.state.selectedEl)
    this.update()
  }

  addCol = (e,el,comp) => {
    e.stopPropagation()
    e.preventDefault()    
    el.content.push({
      type: "col",
      content: {
        type: "new"
      }
    })  
    this.update()
  }  
  removeCol = (e,el,comp) => {
    el.content = el.content.filter(col => col != this.state.selectedEl)
    this.update()    
  }

  changeColContentType = (e,col,type) => {
    e && e.preventDefault()
    if (!col) col = this.state.contentObj.content[0].content[0];
    if (col.type != type) {
      col.type = type
      col.content = null
      this.update()
    }
  }
  selectGrid = (e, el, comp) => {
    // console.log("selectGrid")
    e.stopPropagation()
    e.preventDefault()
    // let alreadySelected = this.state.selected == comp;
    let alreadySelected = false
    this.setState({
      selected: alreadySelected ? null : comp,
      selectedEl: alreadySelected ? null : el,
      input: null
    })
  }
  cancelSelect = (e) => {
    this.setState({
      selected: null,
      selectedEl: null,
      input: null
    })
  }

  handleChange = (e) => {
    e.preventDefault()
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleFocus = (input) => {
    this.setState({
      input: input,
      selected: null,
      selectedEl: null,      
    })
  }
  handleBlur = (input) => {
    
  }  
  handleKeydown = (e) => {
    this.setState({
      keydown: e.keyCode
    })
  }

  mouseMove = (e) => {    
    // console.log("mouseMove",e)
    this.onMouseMove && this.onMouseMove(e)
  }
  mouseUp = (e) => {
    this.onMouseUp && this.onMouseUp(e)
  }

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-sm format-buttons-container">
            {this.props.mode == 'edit' &&
              <FormatButtons input={this.state.input} />
            }
          </div>
        </div>
        <div class="form-group row">
          <div 
            class="col news-editor p-2" 
            onClick={this.cancelSelect} 
            onMouseMove={this.mouseMove}
            onMouseUp={this.mouseUp}
          >
            <Container
              el={this.props.data}
              content={this.props.data.content}
              parent={this}          
              root={this}
              onSelect={this.selectGrid}
              iframes={this.props.iframes}
              mode={this.props.mode} />
          </div>
        </div>
      </div> 
    )
  }

}